import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DownloadIcon } from "../PnLFloorplanDetails/PnLFloorplanIconsSvg.js";
import "./PoppyMultiFlex.scss";
import {
    updateActiveElevation,
    updateActiveFloorplanToPoppy,
} from "../../redux/actions/floorplanActions.js";
import { useHistory } from "react-router-dom";

function PoppyMultiFlex() {
    var dispatch = useDispatch();
    var content = useSelector((state) => state.content.pages.poppy);
    var underViewport = useRef();
    var history = useHistory();

    useEffect(() => {
        function scrollWheelTurned(e) {
            if (typeof underViewport.current != "undefined") {
                underViewport.current.scrollLeft += e.deltaY;
            }
        }

        window.addEventListener("wheel", scrollWheelTurned);

        return () => {
            window.removeEventListener("wheel", scrollWheelTurned);
        };
    });

    function ViewFLoorplanButtonClicked() {
        //have to set the floorplan we want as the active one but i have no idea how to even do that
        console.log("view the floorplan");
        dispatch(updateActiveFloorplanToPoppy());
        dispatch(updateActiveElevation(0));
        history.push("/floorplans/details");
    }

    function letsConnectButtonClicked() {
        history.push("/contact-us");
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (typeof content !== "undefined") {
        return (
            <div className="PoppyMultiFlex-viewport">
                <div className="poppy-multi-flex" ref={underViewport}>
                    {/* landing section */}
                    <div className="poppy-content landing">
                        <div className="content-container">
                            <img className="icon" src={content.landing_icon} />
                            <h2 className="heading">
                                {content.landing_heading}
                            </h2>
                            <p className="copy">
                                <span>
                                    {content.landing_underline_paragraph}
                                    <img
                                        src={content.special_main_underline.url}
                                    />
                                </span>{" "}
                                {content.landing_paragraph}
                            </p>
                        </div>
                        <div className="large-image-container">
                            <img
                                className="large-image"
                                src={content.landing_large_image}
                            />
                        </div>
                        <div className="bottom-bar">
                            <h4 className="bottom-heading">
                                {content.landing_bottom_label}
                            </h4>
                            {content.landing_boxes.length > 0 && (
                                <div class="item-wrapper">
                                    {content.landing_boxes.map((value, key) => (
                                        <div className="item-container">
                                            <div className="item-heading">
                                                {value.heading}
                                            </div>
                                            <div className="item-body">
                                                {value.copy}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Floorplan section */}
                    <div className="poppy-content floorplans">
                        <div className="inner-wrapper">
                            <div className="content-container">
                                <h2 className="content-heading">
                                    {content.floorplan_main_heading}
                                </h2>
                                <p
                                    className="floorplan-contents"
                                    dangerouslySetInnerHTML={{
                                        __html: content.floorplan_main_copy,
                                    }}
                                />
                            </div>
                            <div className="floorplans-container">
                                <div className="floorplan-container">
                                    <div className="image-container">
                                        <img
                                            src={
                                                content.floorplan_plan_one.image
                                            }
                                        />
                                    </div>
                                    <div className="floorplan-label">
                                        {content.floorplan_plan_one.label}
                                    </div>
                                </div>
                                <div className="floorplan-container">
                                    <div className="image-container">
                                        <img
                                            src={
                                                content.floorplan_plan_two.image
                                                    .url
                                            }
                                        />
                                    </div>
                                    <div className="floorplan-label">
                                        {content.floorplan_plan_two.label}
                                    </div>
                                </div>
                            </div>
                            <div className="floorplan-info-container">
                                <h2 className="info-heading">
                                    <strong>
                                        {content.floorplan_info_heading}
                                    </strong>
                                    <br />
                                    <span>
                                        {
                                            content.floorplan_info_under_heading_line
                                        }
                                    </span>
                                </h2>
                                <div className="info-items-container">
                                    {content.floorplan_info_items.map(
                                        (value, key) => (
                                            <div className="info-item">
                                                <span className="number">
                                                    {key + 1}
                                                </span>
                                                <span className="text">
                                                    {value.item_text}
                                                </span>
                                            </div>
                                        )
                                    )}
                                </div>
                                <button
                                    id="poppy-view-floorplan"
                                    className="floorplan-button"
                                    onClick={ViewFLoorplanButtonClicked}
                                >
                                    View Floorplan
                                </button>
                                <br />
                                <a
                                    className="download-button"
                                    href={content.floorplan_download_file}
                                    target="_blank"
                                    download
                                >
                                    <DownloadIcon />
                                    {content.floorplan_download_button_label}
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* Special section */}
                    <div className="poppy-content special">
                        <div className="content-container">
                            <h2 className="main-heading">
                                {content.special_main_heading}{" "}
                                <span>
                                    {content.special_underlined_word}
                                    <img
                                        src={content.special_main_underline.url}
                                    />
                                </span>{" "}
                                {content.special_after_underlined_word}
                            </h2>
                            <p className="main-content">
                                {content.special_main_copy}
                            </p>
                            <button
                                id="poppy-lets-connect"
                                className="main-connect"
                                onClick={letsConnectButtonClicked}
                            >
                                {content.special_connect_button.label}
                            </button>
                        </div>
                        <div class="cards-container">
                            {content.special_card_items.map((item, key) => (
                                <div className="card">
                                    <h3
                                        className="card-heading"
                                        dangerouslySetInnerHTML={{
                                            __html: item.heading,
                                        }}
                                    />
                                    <p className="card-copy">{item.copy}</p>
                                </div>
                            ))}
                        </div>
                        <img
                            class="large-image"
                            src={content.special_large_image.url}
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        return <div />;
    }
}

export default PoppyMultiFlex;
